module.exports = __webpack_public_path__ + "static/media/det.dd17cc5d.png";